import script from "./SearchNoteInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchNoteInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchNoteInput.vue?vue&type=style&index=0&id=098f548f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-098f548f"]])

export default __exports__